import React, { useState, useEffect, useCallback } from 'react';
import { Input, Select, Form, InputNumber, Button } from 'antd';
import { parseSelectOptions } from 'utils/formUtils';
import _ from 'lodash';

export const DEFAULTS = {
  number: 15,
  durationType: 'Days',
  neverOrAfter: 'After'
};

const CustomDuration = ({ onChange, onUpdate, size="default", showNeverOption = false, extra = null, maxLimitInYears = 5, ...props }) => {
  const [isActive, setIsActive] = useState(true);

  const durationType = props.value?.durationType;

  function calculateReopen(input) {
    if (input === 'Days') 
    return maxLimitInYears * 365;
    else if (input === 'Weeks') 
    return maxLimitInYears * 52;
    else if (input === 'Months')
    return maxLimitInYears * 12;
    else return undefined;
  }

  const dynamicLimit = maxLimitInYears ? calculateReopen(durationType) : undefined

  const onNeverChange = useCallback((value) => {
    setIsActive(value !== "Never");
    onUpdate && onUpdate(value);
  }, [onUpdate]);

  useEffect(() => {
    setIsActive(props.value?.neverOrAfter !== "Never" || !showNeverOption);
  }, [props.value?.neverOrAfter, showNeverOption]);  

  
  return (
    <>
    <Input.Group compact>
      <Form.Item noStyle
        name={[...(_.isArray(props.name) ? props.name : [props.name]), 'neverOrAfter']}>
        {
          !showNeverOption ? <Button size={size} style={{ width: '33%' }} value="After">After</Button>
          : <Select style={{ width: '33%' }} size={size} options={parseSelectOptions(["After", "Never"])} onChange={onNeverChange} />
        }
      </Form.Item>
      <Form.Item noStyle
        name={[...(_.isArray(props.name) ? props.name : [props.name]), 'number']}>
        <InputNumber onChange={onUpdate} size={size} style={{ width: '33%' }} min={1} max={dynamicLimit} controls={false} disabled={!isActive} />
      </Form.Item>
      <Form.Item noStyle
        name={[...(_.isArray(props.name) ? props.name : [props.name]), 'durationType']}>
        <Select onChange={onUpdate} size={size} style={{ width: '33%' }} disabled={!isActive} options={parseSelectOptions(["Days", "Weeks", "Months"])} />
      </Form.Item>
      </Input.Group>
      {extra}
    </>
  );
};

export default CustomDuration;

export const requiredValidation = () => {
  return {
    validator: (field, value) => {
      if (_.isUndefined(value) || (value.neverOrAfter === "After" && (_.isEmpty(value.durationType) || _.isUndefined(value.number) || _.isNull(value.number)))) {
        return Promise.reject(<>Please select all 3 fields</>);
      } else {
        return Promise.resolve();
      }
    }
  }
}
